

import Component from 'generic.basecomponent';
import $ from 'jquery';
import Accordion from './plugins/jquery-ui';
import FormValidityHandler from '../../form/js/form-validity-handler';

export default class AccordionEl extends Component {
    constructor(el) {
        super(el);

        this.$container = $(this.container);
        const customSettings = this.$container.data('accordionSettings') || {};
        this.settings = Object.assign({}, AccordionEl._settings, customSettings);
        this.$nextButton = this.$container.find('.js-accordion-next');

        this.initAccordion();
    }

    initAccordion() {
        this.$container.accordion(this.settings);
        this.instance = this.$container.accordion('instance');


        const $arrowElement = this.$container.find('.ui-icon');

        $arrowElement.append('<svg class=\'icon icon--arrow-down\'><use xmlns:xlink=\'http://www.w3.org/1999/xlink\' xlink:href=\'#icon-arrow-down\'></use></svg>');

        const $panels = this.$container.find('.panel');
        const formNode = this.$container.closest('.js-validated-form')[0];
        $panels.each((i, element) => {
            new FormValidityHandler({
                element,
                formNode,
                onFailed: this.onInnerFieldNotValid.bind(this, element),
                beforeSubmit: this.onBeforeSubmit.bind(this, element)
            });
        });

        this.$nextButton.on('click', this.onClickNext.bind(this));
    }

    onClickNext() {
        const nextIndex = this.getNextPanelIndex();

        this.$container.accordion('option', 'active', nextIndex);
    }

    onInnerFieldNotValid(el) {
        el.classList.add('is-invalid-panel');
        const siblings = [...el.parentNode.children];
        const index = siblings.indexOf(el);

        let mustOpenPanel = true;
        for (let i = 0; i < index; i++) {
            if (siblings[i].classList.contains('is-invalid-panel')) {
                mustOpenPanel = false;
            }
        }
        if (mustOpenPanel) {
            this.$container.accordion('option', 'active', index);
        }
    }

    onBeforeSubmit(el) {
        el.classList.remove('is-invalid-panel');
    }


    getNextPanelIndex() {
        const currentIndex = this.instance.options.active;
        const length = this.instance.panels.length;

        return (currentIndex + 1 < length) ? currentIndex + 1 : 0;
    }
}

AccordionEl._settings = {
    header: '.panel-heading',
    collapsible: 'true',
    active: 'false',
    heightStyle: 'content',
    activate: (event, ui) => {
        const header = ui.newHeader[0];
        if (header) {
            const offsetTop = header.getBoundingClientRect().top;
            if (offsetTop < 0) {
                $('html:not(:animated), body:not(:animated)').animate({ scrollTop: window.pageYOffset + offsetTop }, 200);
            }
        }
    }
};



// WEBPACK FOOTER //
// ./app/components/accordion/js/generic.accordion.js